<template>
  <panel class="project-overview-ct">
    <div class="header">
      <a :href="projectUrl">
        <img v-if="projectIcon" class="icon" :src="projectIcon" />
        <img v-else src="@/img/icon/app-ico.png" class="icon" />
      </a>
      <a :href="projectUrl">
        <h3>{{ projectName }}</h3>
      </a>
      <el-tag
        size="mini"
        effect="plain"
        class="project-inactive"
        type="warning"
        v-if="projectStatus !== ProjectStatusEnum.ACTIVE"
      >
        {{ $t('CompanyDashboard_ProjectInactive') }}
      </el-tag>
    </div>

    <div class="metrics">
      <template v-for="(metric, index) in metrics">
        <metric
          :key="index"
          :title="
            metricLabels.hasOwnProperty(metric.name)
              ? $t(metricLabels[metric.name])
              : metric.name
          "
          :metric="metric.value"
          :type="metric.type"
          class="metric"
        />
      </template>
    </div>

    <buttons :project-id="projectId" :workflow="workflow" />
  </panel>
</template>

<script>
import Panel from '@/common/components/Panel'
import Metric from '@/common/components/Metric'
import Buttons from '@/common/components/ProjectOverviewButtons'
import { metricLabels } from '@/common/components/dashboard/Labels'
import { ProjectStatusEnum } from '@/common/enum/ProjectStatusEnum'

export default {
  name: 'ProjectOverview',

  components: { Panel, Metric, Buttons },

  props: {
    projectId: {
      type: Number,
      required: true
    },
    projectStatus: {
      type: String,
      required: false
    },
    projectName: {
      type: String,
      required: true
    },
    projectIcon: {
      type: String,
      required: false
    },
    metrics: {
      type: Array,
      required: true
    },
    workflow: {
      type: Number
    }
  },

  data() {
    return {
      metricLabels,
      ProjectStatusEnum
    }
  },
  computed: {
    projectUrl() {
      if (this.$can('viewProjectAnalytics')) {
        return `/analytics/analytics/index?project_id=${this.projectId}`
      }
      if (this.$can('Profile::Read')) {
        return `/profiles?project_id=${this.projectId}`
      }
      return `/push/campaign-template/index?project_id=${this.projectId}`
    }
  }
}
</script>

<style scoped>
.project-overview-ct {
  width: 536px;
}

.metrics {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.metrics .metric {
  margin-bottom: 20px;
  height: 52px;
  flex-basis: 33%;
}

.header {
  display: flex;
  align-items: center;
  padding-bottom: 24px;
}

h3 {
  margin-bottom: 4px;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #1d87c8;
  display: inline-block;
}

.icon {
  border-radius: 50%;
  width: 32px;
  height: 32px;
  margin-right: 18px;
}

.project-inactive {
  margin-bottom: 4px;
  margin-left: 9px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/ProjectOverview.vue